import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import {
  AdminUtilityRailService,
  AdminUtilityTool,
} from './admin-utility-rail.service';

/**
 * Rail derecho estilo Gmail: palanquita + iconos de utilidades rápidas.
 * Contador de efectivo vive aquí (sheet), gated por gema; no es ítem del menú Finanzas.
 */
@Component({
  selector: 'app-admin-utility-rail',
  standalone: true,
  imports: [MaterialModule, TranslateModule],
  templateUrl: './admin-utility-rail.component.html',
  styleUrl: './admin-utility-rail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminUtilityRailComponent {
  readonly rail = inject(AdminUtilityRailService);

  toggle(): void {
    this.rail.toggleExpanded();
  }

  openTool(tool: AdminUtilityTool): void {
    this.rail.openTool(tool.id);
  }
}
